<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { UngroupIcon } from "lucide-vue-next";
import { useSuggestionContext } from "../suggestions";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";
import { useDocumentCommandContext } from "./context";

const props = defineProps<CommandItemBaseProps>();

const { isBrowseAiButtons } = useDocumentCommandContext();
const { reset } = useSuggestionContext();

function run() {
  // clear query to reset suggestion list
  props.editor
    .chain()
    .focus()
    .deleteRange({
      from: props.range.from + 1,
      to: props.range.to,
    })
    .run();
  reset();
  isBrowseAiButtons.value = true;
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :icon="UngroupIcon"
    @click="run"
    @keydown.enter="run"
  >
    Browse AI snippets
  </SuggestionListItem>
</template>
